import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';

export interface GlitchEffectProperties extends EffectProperties {
  delay: number;
  duration: number;
  strength: number;
}

// Create a reusable Glitch component that can be used in both preview and world
const GlitchComponent = forwardRef<any, { properties: GlitchEffectProperties; isPreview?: boolean }>((props, ref) => {
  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }

  const { delay, duration, strength } = properties;

  return (
    <PostProcessing.Glitch
      ref={ref}
      delay={new THREE.Vector2(delay, delay)}
      duration={new THREE.Vector2(duration, duration)}
      strength={new THREE.Vector2(strength, strength)}
    />
  );
});

export const GlitchEffectItem: Effect<GlitchEffectProperties> = {
  id: '',
  name: 'Glitch',
  type: 'effect',
  subtype: 'Glitch',
  icon: 'Effect',
  properties: {
    delay: 1.5,
    duration: 0.6,
    strength: 0.3,
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.delay',
      type: 'number',
      label: 'Delay',
      default: 1.5,
      min: 0,
      max: 10,
      step: 0.1,
      panel: 'effect',
    },
    {
      key: 'properties.duration',
      type: 'number',
      label: 'Duration',
      default: 0.6,
      min: 0,
      max: 5,
      step: 0.1,
      panel: 'effect',
    },
    {
      key: 'properties.strength',
      type: 'number',
      label: 'Strength',
      default: 0.3,
      min: 0,
      max: 1,
      step: 0.01,
      panel: 'effect',
    }
  ],
  render: (properties: GlitchEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <GlitchComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
};